import { Input } from 'antd';
import { useRef, useState, useLayoutEffect, type FC } from 'react';

import type { FilterProps } from '@app/components/Filter/types/Filter.types';
import { useOutsideClick } from '@app/hooks';

import '@app/components/Filter/styles/Filter.desktop.scss';
import '@app/components/Filter/styles/Filter.mobile.scss';

export const Filter: FC<FilterProps> = ({
  expanded = false,
  label,
  selectedCount = 0,
  showSearch = false,
  showSelectAll = false,
  selectAllSelected = false,
  children = [],
  onSelectAll,
  onClick,
  onSearch,
  className,
  handleOutsideClick,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const overlayRef = useRef<HTMLDivElement | null>(null);
  const [alignRight, setAlignRight] = useState(false);

  useOutsideClick(ref, handleOutsideClick, expanded || false);

  useLayoutEffect(() => {
    if (expanded && overlayRef.current && ref.current) {
      const containerRect = ref.current.getBoundingClientRect();
      const overlayRect = overlayRef.current.getBoundingClientRect();
      if (containerRect.left + overlayRect.width > window.innerWidth) {
        setAlignRight(true);
      } else {
        setAlignRight(false);
      }
    }
  }, [expanded]);

  return (
    <div className={`filter${className ? ` ${className}` : ''}`} ref={ref}>
      <div
        className={`filter-label ${expanded ? 'expanded' : ''}`}
        onClick={onClick}
      >
        {typeof label === 'string' ? <label>{label}</label> : label}
        {selectedCount > 0 && (
          <span className="selected-items-count">({selectedCount})</span>
        )}
        {expanded !== null && (
          <span className={`triangle ${expanded ? 'expanded' : ''}`}>›</span>
        )}
      </div>
      {expanded && (
        <div
          className={`filter-overlay${alignRight ? ' right-aligned' : ''}`}
          ref={overlayRef}
        >
          {showSearch && (
            <Input
              placeholder="Поиск"
              className="search-input"
              onChange={(e) => onSearch(e.target.value)}
            />
          )}
          {showSelectAll && (
            <div className="select-all" onClick={onSelectAll}>
              <input type="checkbox" checked={selectAllSelected} readOnly />
              <span>Выбрать все</span>
            </div>
          )}
          <div className="filter-options">{children}</div>
        </div>
      )}
    </div>
  );
};
